<template>
  <cart-item-dialog />
</template>

<script>
import CartItemDialog from '~/components/CartItemDialog'

export default {
  name: 'cart-item-view',
  metaInfo () {
    return { title: 'Basket Item' }
  },
  components: {
    'cart-item-dialog': CartItemDialog
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/cart_item.vue